import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Accordion } from 'react-accessible-accordion';
import ReactHtmlParser from 'react-html-parser';
import Glide from '@glidejs/glide';
import {
  Paragraph,
  Section,
  SectionHeader,
  Accordion as AccordionCustom,
} from 'components';
import { data } from './logic.js';
import './ProcessAndTools.scss';

class ProcessAndTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
    };
  }

  componentDidMount() {
    this.glide = new Glide('.process-and-tools__slider', {
      type: 'slider',
      startAt: 0,
      perView: 1,
      animationDuration: 300,
      gap: 0,
      dragThreshold: false,
      autoplay: 3000,
      classes: {
        activeNav: 'active',
      },
    });

    this.glide.on(['build.after', 'run.after'], () => {
      this.setState({ currentSlide: this.glide.index });
    });

    this.glide.mount();
  }

  renderItem = () =>
    data.map(item => (
      <li className={'process-and-tools__item glide__slide'}>
        <SectionHeader
          size={'small'}
          lineColor={'white'}
          color={'white'}
          descriptionColor={'white'}
          headingType={3}
          description={item.description}
          fixed
        >
          {item.title}
        </SectionHeader>
      </li>
    ));

  renderTitle = () =>
    data.map((item, index) => (
      <li
        className={`process-and-tools__title glide__bullet ${
          this.state.currentSlide === index ? 'active' : ''
        }`}
        onClick={() => this.glide.go(`=${index}`)}
        role={'presentation'}
      >
        <Paragraph color={'red'} size={'medium'}>
          {item.title}
        </Paragraph>
      </li>
    ));

  renderAccordion = () =>
    data.map((item, index) => (
      <>
        <AccordionCustom
          additionalClass={'accordion__slider-item hide-tablet hide-desktop'}
          id={'prototyping-team'}
          backgroundColor={'mine-shaft'}
          headline={item.title}
          description={ReactHtmlParser(item.description)}
          lineColor={'red'}
          fontColors={['white', 'white', 'white']}
          index={index + 1}
          expandFirst
        />
      </>
    ));

  renderNavBullets = () =>
    data.map((item, index) => (
      <button
        className={'process-and-tools__bullet glide__bullet'}
        data-glide-dir={`=${index}`}
      />
    ));

  render() {
    return (
      <Section color={'mine-shaft'}>
        <SectionHeader
          size={'big'}
          lineColor={'red'}
          color={'white'}
          descriptionColor={'white'}
          headingType={2}
          description={
            'Over the years of offering Digital Transformation Services, we have developed a number of processes and mastered many tools that allow our clients to shorten the transition and make it more effective.'
          }
          fixed
        >
          Process
          <br />
          and Tools
        </SectionHeader>
        <Accordion>{this.renderAccordion()}</Accordion>
        <div className={'process-and-tools__slider glide hide-mobile'}>
          <Row>
            <Col sm={12} md={6}>
              <ol className={'process-and-tools__list-nav'}>
                {this.glide && this.renderTitle()}
              </ol>
            </Col>
            <Col sm={12} md={6} className={'hide-mobile'}>
              <div data-glide-el={'track'} className={'glide__track'}>
                <ul className={'glide__slides'}>{this.renderItem()}</ul>
              </div>
              <div
                className={'process-and-tools__nav glide__bullets'}
                data-glide-el={'controls[nav]'}
              >
                {this.renderNavBullets()}
              </div>
            </Col>
          </Row>
        </div>
      </Section>
    );
  }
}

export default ProcessAndTools;
